<app-group-info
  [(mode)]="mode"
  [type]="type"
  [data]="data"
  [isChannel]="isChannel"
  [organisationId]="organisationId"
  [initFilter]="initFilter"
  [allowSubscribing]="allowSubscribing"
  [allowSpecialFieldsViewing]="allowSpecialFieldsViewing"
  [loading]="loading"
  (create)="create($event)"
  (edit)="edit($event)"
  (canceled)="canceled.emit()"
  (deleted)="deleted.emit()"
></app-group-info>
